import { useApolloClient } from "@apollo/client";
import { useRefract } from "refract-rxjs";

import { type GetLensInfoCardsInput, type GetLensInfoCardsOutput, getTopLensesCardsEffect } from "../effects";
import { type LensCard } from "../models";

import { useTopLensesStats } from "./useTopLensesStats";

export const useLensInfoCards = (): { topLensesCards: LensCard[]; isLoading: boolean; isEmpty: boolean } => {
    const client = useApolloClient();
    const { topLensesStats, loading: topLensesStatsLoading } = useTopLensesStats();

    const {
        topLensesCards: { lensCards, isEmpty, isFilled },
    } = useRefract<GetLensInfoCardsInput<typeof client>, GetLensInfoCardsOutput>(getTopLensesCardsEffect, {
        topLensesStats,
        topLensesStatsLoading,
        client,
    });

    return {
        topLensesCards: lensCards,
        isLoading: !isFilled && !isEmpty,
        isEmpty,
    };
};
